import { render, staticRenderFns } from "./UcAccountSelectOption.yaml?vue&type=template&id=95896bc2&component"
import script from "./UcAccountSelectOption.yaml?vue&type=script&lang=ts&component"
export * from "./UcAccountSelectOption.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports